import React, { Component } from 'react'

export default class DataBlock extends Component {
    render() {
        return <div className="data_block">{this.props.children}</div>
    }
}

DataBlock.propTypes = {}
